document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.color-swatch');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const media = card.querySelector('.media');
  const newSrc = swatch.dataset.image;

  if (!media || !newSrc) return;

  // ⛔ Prevent reloading same image
  const currentImg = media.querySelector('img');
  if (currentImg && currentImg.src === newSrc) return;

  // ✅ Replace ONLY product image (not swatch image)
  media.innerHTML = `
    <img
      src="${newSrc}"
      srcset="${newSrc} 900w"
      sizes="(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw"
      loading="lazy"
      class="motion-reduce"
      alt=""
    >
  `;

  // ✅ Active swatch UI
  card.querySelectorAll('.color-swatch').forEach(el =>
    el.classList.remove('is-active')
  );
  swatch.classList.add('is-active');

  // ✅ Save variant for redirect
  card.dataset.variantId = swatch.dataset.variantId;
});


// ✅ Append variant ONLY when clicking product link
document.addEventListener('click', function (e) {
  const link = e.target.closest('.card-wrapper a.full-unstyled-link');
  if (!link) return;

  const card = link.closest('.card-wrapper');
  if (!card || !card.dataset.variantId) return;

  const url = new URL(link.href);
  url.searchParams.set('variant', card.dataset.variantId);
  link.href = url.toString();
});
